/**
 * Whether a crosstab is on an iOOH Brand Lift study. The one rule the workspace reads, for the
 * iOOH base (`isIoohProject`) and for the significance an iOOH crosstab starts on
 * (`IOOH_CONFIDENCE`), so the two can never disagree about which study is which.
 *
 * The primary signal is two or more of the iOOH section questions in the catalog. Failing that, the
 * crosstab's name says so: a study whose questions use other QIDs but whose Salesforce project name
 * was set correctly (e.g. "2024-12-31480-OGXBrandLift").
 */

/** The iOOH section questions, upper-cased. OOHRECALL is an alias some surveys use for OOHAR. */
export const IOOH_SECTION_QIDS: ReadonlySet<string> = new Set([
    'OOHUBA',
    'OOHABA',
    'OOHUAA',
    'OOHAAA',
    'OOHAR',
    'OOHRECALL',
    'OOHMM',
    'OOHLIKE',
    'OOHABO',
    'OOHBO',
    'OOHCON',
    'OOHPUR',
    'OOHNPS',
    'OOHPEXP',
]);

/** Words in a crosstab's name, lower-cased, that mark an iOOH study. */
const IOOH_NAME_WORDS = ['brandlift', 'brand lift', 'brand_lift', 'iooh', 'ooh study'];

export function isIoohStudy(questions: readonly { qid: string }[], name: string): boolean {
    const sections = questions.filter((q) => IOOH_SECTION_QIDS.has(q.qid.toUpperCase()));
    if (sections.length >= 2) return true;
    const lowerName = name.toLowerCase();
    return IOOH_NAME_WORDS.some((word) => lowerName.includes(word));
}
